var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-card", {
        staticClass: "cardClassDetailForm",
        attrs: { title: "메일 발송" },
        scopedSlots: _vm._u([
          {
            key: "card-button",
            fn: function () {
              return [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: {
                            isSubmit: _vm.isSend,
                            url: _vm.sendMailUrl,
                            param: _vm.sendPayload,
                            mappingType: "POST",
                            label: "메일 발송",
                            icon: "mail",
                          },
                          on: {
                            beforeAction: _vm.sendMail,
                            btnCallback: _vm.sendMailCallback,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "card-detail",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-4" },
                  [
                    _c("c-table", {
                      ref: "userTable",
                      attrs: {
                        title: "메일 발송 대상 목록",
                        columns: _vm.userColumns,
                        data: _vm.users,
                        gridHeight: _vm.gridHeight,
                        columnSetting: false,
                        filtering: false,
                        usePaging: false,
                        isFullScreen: false,
                        editable: _vm.editable,
                        selection: "multiple",
                        rowKey: "userId",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "table-button",
                          fn: function () {
                            return [
                              _vm.editable
                                ? _c(
                                    "q-btn-group",
                                    { attrs: { outline: "" } },
                                    [
                                      _c("c-btn", {
                                        attrs: { label: "추가", icon: "add" },
                                        on: { btnClicked: _vm.addUser },
                                      }),
                                      _c("c-btn", {
                                        attrs: {
                                          label: "제외",
                                          icon: "remove",
                                        },
                                        on: { btnClicked: _vm.excludeUsers },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-8" },
                  [
                    _c("c-table", {
                      attrs: {
                        title: "규제 변경 목록",
                        columns: _vm.historyColumns,
                        data: _vm.histories,
                        gridHeight: _vm.gridHeight,
                        usePaging: false,
                        isFullScreen: false,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.addPopupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }